export type ProductSortingEvent = {
    event: 'product_sorting';
    sortingSelected: string;
};

export const trackProductSortingEvent = (sortingSelected: string): ProductSortingEvent => ({
    event: 'product_sorting',
    sortingSelected,
});
